export interface StandardizedArticle {
    category: Category;
    products: StandardizedProduct[];
}

export interface StandardizedProduct {
    gtin: string;
    size: string;
    selectedQuantity: number;
    availableQuantity: number;
    soldQuantity?: number;
    retailerStock?: number;
    brandStock?: {
        available: number;
        backorder?: {
            available: number;
            deliveryFrom: string;
            deliveryTo: string;
        };
    };
}

export enum Category {
    Wallets = 'wallets',
    Glasses = 'glasses',
    Bags = 'bags',
    Equipment = 'equipment',
    Sleepwear = 'sleepwear',
    DenimPants = 'denimPants',
    WaterSportsEquipment = 'waterSportsEquipment',
    BlousesChemises = 'blousesChemises',
    Accessories = 'accessories',
    ShoeHeels = 'shoeHeels',
    Shirts = 'shirts',
    Protection = 'protection',
    OutdoorJackets = 'outdoorJackets',
    ShoeFlats = 'shoeFlats',
    SuitsBlazers = 'suitsBlazers',
    Belts = 'belts',
    Pullover = 'pullover',
    Ties = 'ties',
    Gloves = 'gloves',
    Swimwear = 'swimwear',
    Scarves = 'scarves',
    Pants = 'pants',
    Cufflinks = 'cufflinks',
    Headdress = 'headdress',
    Underwear = 'underwear',
    Jumpsuits = 'jumpsuits',
    Jewelry = 'jewelry',
    Hosiery = 'hosiery',
    Vests = 'vests',
    BowTies = 'bowTies',
    Shoes = 'shoes',
    HomeTextiles = 'homeTextiles',
    PosMaterial = 'posMaterial',
    Skirts = 'skirts',
    IndoorJackets = 'indoorJackets',
    Other = 'other',
    Dresses = 'dresses',
    DressHandkerchiefs = 'dressHandkerchiefs'
}

export enum SizePrefixMap {
    length = 'L',
    width = 'W'
}

export enum ArticleSource {
    Details = 'articleDetails',
    CardV4 = 'articleCardV4',
    CardLegacy = 'articleLegacy',
    SearchArticle = 'smartReplenishmentSearchArticle'
}

export type DetailedSize = {
    size: string;
    subSize: string;
    sizeType: SizeType;
    subSizeType: SizeType;
    sizeSystem: string;
};

export enum SizeType {
    Width = 'width',
    Length = 'length'
}
